// extracted by mini-css-extract-plugin
module.exports = {"nav":"view_navigation_nav__YR6Bq","items":"view_navigation_items__1Kgv_","item":"view_navigation_item__19yBB","current":"view_navigation_current__1tPG_"};